import { GlobalContants } from "src/app/common/constants/global.contants";
import { ReportTableColumn } from "../../models/reports.model";
import { OccupancyRentalV2MenuEnum } from "./report-occupancy-rental-v2.enum";
import { DataType } from "src/app/common/models/enums/common.enum";

export class ReportOccupancyRentalV2Constants {
    static overViewMenu = [
        {
            label: 'reports.overview',
            name: OccupancyRentalV2MenuEnum.overview,
        },
        {
            label: 'reports.residential_units_grade_wise',
            name: OccupancyRentalV2MenuEnum.residentialUnitsGradeWise,
        },
        {
            label: 'reports.residential_units_type_wise',
            name: OccupancyRentalV2MenuEnum.residentialUnitsTypeWise,
        },
        {
            label: 'reports.commercial_units_grade_wise',
            name: OccupancyRentalV2MenuEnum.commercialUnitsGradeWise,
        },
        {
            label: 'reports.commercial_units_size_wise',
            name: OccupancyRentalV2MenuEnum.commercialUnitsSizeWise,
        },
        {
            label: 'reports.propertyRentalTransaction',
            name: OccupancyRentalV2MenuEnum.unitRentalTransaction,
        },
    ]
    static residentialGradeColumns: ReportTableColumn[] = [
        {
            header: 'neighborhood',
            columnName: 'reports.NEIGHBORHOODS',
            field: 'neighborhood',
            isSortable: false,
            border: false,
            isContainsHTML: false,
            convertNumber: false,
            showOnMap: true,
        },
        {
            header: 'occupancy',
            columnName: 'reports.occupancy',
            field: 'occupancy',
            isSortable: false,
            border: false,
            isContainsHTML: false,
            convertNumber: true,
        },

        {
            header: 'average_size',
            columnName: 'reports.AverageSize',
            field: 'average_size',
            isSortable: false,
            border: false,
            isContainsHTML: false,
            convertNumber: true,
            symbol: DataType.squareMeter,
            isBreak: true
        },
        {
            header: 'rentals_as_lumpsum',
            columnName: 'reports.rentals_as_lumpsum',
            field: 'rentals_as_lumpsum',
            border: false,
            isSortable: false,
            isContainsHTML: false,
            convertNumber: true,
            symbol: DataType.currencyCode,
            isBreak: true
        },
        {
            header: 'rental_rate',
            columnName: 'reports.monthly_rental_rate',
            field: 'rental_rate',
            border: false,
            isSortable: false,
            isContainsHTML: false,
            convertNumber: true,
            symbol: DataType.currencyWithSquareMeter,
            isBreak: true
        }
    ]
    static residentialTypeColumns: ReportTableColumn[] = [
        {
            header: 'neighborhood',
            columnName: 'reports.NEIGHBORHOODS',
            field: 'neighborhood',
            isSortable: false,
            border: false,
            isContainsHTML: false,
            convertNumber: false,
            showOnMap: true,
        },
        {
            header: 'occupancy',
            columnName: 'reports.occupancy',
            field: 'occupancy',
            isSortable: false,
            border: false,
            isContainsHTML: false,
            convertNumber: true,
        },

        {
            header: 'average_size',
            columnName: 'reports.AverageSize',
            field: 'average_size',
            isSortable: false,
            border: false,
            isContainsHTML: false,
            convertNumber: true,
            symbol: DataType.squareMeter,
            isBreak: true
        },
        {
            header: 'rentals_as_lumpsum',
            columnName: 'reports.rentals_as_lumpsum',
            field: 'rentals_as_lumpsum',
            border: false,
            isSortable: false,
            isContainsHTML: false,
            convertNumber: true,
            symbol: DataType.currencyCode,
            isBreak: true
        },
        {
            header: 'rental_rate',
            // columnName: 'reports.monthly_rentals',
            columnName: 'reports.monthly_rental_rate',
            field: 'rental_rate',
            border: false,
            isSortable: false,
            isContainsHTML: false,
            convertNumber: true,
            symbol: DataType.currencyWithSquareMeter,
            isBreak: true
        }
    ]
    static commercialGradeColumns: ReportTableColumn[] = [
        {
            header: 'neighborhood',
            columnName: 'reports.NEIGHBORHOODS',
            field: 'neighborhood',
            isSortable: false,
            border: false,
            isContainsHTML: false,
            convertNumber: false,
            showOnMap: true,
        },
        {
            header: 'occupancy',
            columnName: 'reports.occupancy',
            field: 'occupancy',
            isSortable: false,
            border: false,
            isContainsHTML: false,
            convertNumber: true,
        },
        {
            header: 'retails',
            columnName: 'retail',
            field: 'retails',
            isSortable: false,
            border: false,
            isContainsHTML: false,
            convertNumber: true,
            symbol: DataType.currencyWithSquareMeter,
            isBreak: true
        },
        {
            header: 'commercial',
            columnName: 'reports.commercial',
            field: 'commercial',
            isSortable: false,
            border: false,
            isContainsHTML: false,
            convertNumber: true,
            symbol: DataType.currencyWithSquareMeter,
            isBreak: true
        },
        {
            header: 'clinic',
            columnName: 'reports.clinics',
            field: 'clinic',
            isSortable: false,
            border: false,
            isContainsHTML: false,
            convertNumber: true,
            symbol: DataType.currencyWithSquareMeter,
            isBreak: true
        },
        {
            header: 'professional',
            columnName: 'reports.professional',
            field: 'professional',
            border: false,
            isSortable: false,
            isContainsHTML: false,
            convertNumber: true,
            symbol: DataType.currencyWithSquareMeter,
            isBreak: true
        }
    ]
    static commercialSizeColumns: ReportTableColumn[] = [
        {
            header: 'neighborhood',
            columnName: 'reports.NEIGHBORHOODS',
            field: 'neighborhood',
            isSortable: false,
            border: false,
            isContainsHTML: false,
            convertNumber: false,
            showOnMap: true,
        },
        {
            header: 'occupancy',
            columnName: 'reports.occupancy',
            field: 'occupancy',
            isSortable: false,
            border: false,
            isContainsHTML: false,
            convertNumber: true,
        },
        {
            header: 'retails',
            columnName: 'retail',
            field: 'retails',
            isSortable: false,
            border: false,
            isContainsHTML: false,
            convertNumber: true,
            symbol: DataType.currencyWithSquareMeter,
            isBreak: true
        },
        {
            header: 'commercial',
            columnName: 'reports.commercial',
            field: 'commercial',
            isSortable: false,
            border: false,
            isContainsHTML: false,
            convertNumber: true,
            symbol: DataType.currencyWithSquareMeter,
            isBreak: true
        },
        {
            header: 'clinic',
            columnName: 'reports.clinics',
            field: 'clinic',
            isSortable: false,
            border: false,
            isContainsHTML: false,
            convertNumber: true,
            symbol: DataType.currencyWithSquareMeter,
            isBreak: true
        },
        {
            header: 'professional',
            columnName: 'reports.professional',
            field: 'professional',
            border: false,
            isSortable: false,
            isContainsHTML: false,
            convertNumber: true,
            symbol: DataType.currencyWithSquareMeter,
            isBreak: true
        }
    ]
    static transactionColumns: ReportTableColumn[] = [
        {
            header: 'property_project_name',
            columnName: 'reports.propertyNameProjectName',
            field: 'property_project_name',
            isSortable: false,
            border: false,
            isContainsHTML: false,
            convertNumber: false,
            showOnMap: true,
            isAnchor: true
        },
        {
            header: 'unit_type',
            columnName: 'reports.unitType',
            field: 'unit_type',
            isSortable: false,
            border: false,
            isContainsHTML: false,
            convertNumber: false,
        },
        
        // {
        //     header: 'no_of_units',
        //     columnName: 'reports.noOfUnits',
        //     field: 'no_of_units',
        //     isSortable: false,
        //     border: false,
        //     isContainsHTML: false,
        //     convertNumber: false,
        // },
        {
            header: 'unit_size',
            columnName: 'reports.unit_size',
            field: 'unit_size',
            isSortable: false,
            border: false,
            isContainsHTML: false,
            convertNumber: false,
            symbol: DataType.squareMeter
        },
        {
            header: 'rental_lumpsum',
            columnName: 'reports.rental_lumpsum',
            field: 'rental_lumpsum',
            isSortable: false,
            border: false,
            isContainsHTML: false,
            convertNumber: false,
            symbol: DataType.currencyMonthly
        },
        {
            header: 'rental_rate',
            columnName: 'reports.rental_rate',
            field: 'rental_rate',
            border: false,
            isSortable: false,
            isContainsHTML: false,
            convertNumber: false,
            symbol: DataType.currencyWithSquareMonthly
        }
    ]
}
